<template>
  <div class="main" id="main">
    <div class="leftWrap">
      <img class="logo" src="images/logo.png" alt="" srcset="">
      <p class="phoneNum" v-if="phoneShow">13160057058</p>
      <img class="phone" src="images/phone.png" alt="" srcset="" @mouseover="phoneShow=true" @mouseleave="phoneShow=false">
      <img class="weixin" src="images/weixin.png" alt="" srcset="">
      <img class="qr" src="images/qr.png" alt="" srcset="">
    </div>
    <div class="rightWrap">
      <swiper ref="mySwiper" :options="swiperOptions" class="myswiper">
        <swiper-slide class="myslide">
          <video ref="myvideo" src="videos/1.mp4" @click="play"></video>
        </swiper-slide>
        <swiper-slide class="myslide">
          <img class="bgImg" src="images/bg2.jpg" alt="">
          <img v-if="activeNum==1" class="title1" src="images/title1.png" alt="" srcset="">
          <p v-if="activeNum==1" class="info1">是一款可承载大容量的数据库，所有信息以绚丽的画面形式呈现在大众面前，随着每一条信息被观众点击，内容会以文字、图片、视频、三维的形式打开，此时“显示信息”与“待命信息”展示在两个完全不同不被干扰的层面相互分离。</p>
        </swiper-slide>
        <swiper-slide class="myslide">
          <img class="bgImg" src="images/bg1.jpg" alt="">
          <p class="name1">掌上延伸</p>
          <img v-if="activeNum==2" class="pic1" src="images/1.png" alt="">
        </swiper-slide>
        <swiper-slide class="myslide">
          <img class="bgImg" src="images/bg1.jpg" alt="">
          <p class="name1">自媒体平台引流</p>
          <img v-if="activeNum==3" class="pic2" src="images/2.png" alt="">
        </swiper-slide>
        <swiper-slide class="myslide">
          <img class="bgImg" src="images/bg1.jpg" alt="">
          <p class="name1">远程诊断及监控系统</p>
          <img v-if="activeNum==4" class="pic3" src="images/3.png" alt="">
        </swiper-slide>
        <swiper-slide class="myslide">
          <img class="bgImg" src="images/bg1.jpg" alt="">
          <p class="name1">收集数据</p>
          <img v-if="activeNum==5" class="pic3" src="images/4.png" alt="">
        </swiper-slide>
        <swiper-slide class="myslide">
          <img class="bgImg" src="images/bg3.jpg" alt="">
          <p class="name1">发布仪式</p>
          <img v-if="activeNum==6" class="pic4" src="images/5.png" alt="">
        </swiper-slide>
      </swiper>
      <div class="tipWrap">
        <img class="mouse" src="images/mouse.png" alt="" srcset="">
        <img class="arrow1" src="images/arrow_1.png" alt="" srcset="">
        <img class="arrow2" src="images/arrow_1.png" alt="" srcset="">
      </div>
    </div>
  </div>
</template>
<style scoped>
  .main{
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  .tipWrap{
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    width: 42px;
    height: 100px;
    z-index: 999;
  }
  .tipWrap .mouse{
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
  }
  .tipWrap .arrow1{
    position: absolute;
    left: 50%;
    top: 70px;
    transform: translateX(-50%);
    animation: ani1 1s linear infinite;
  }
  @keyframes ani1 {
    0%{opacity: 1;}
    50%{opacity: 0.5;}
    100%{opacity: 1;}
  }
  .tipWrap .arrow2{
    position: absolute;
    left: 50%;
    top: 85px;
    transform: translateX(-50%);
    animation: ani1 1s 0.5s linear infinite;
  }
  .leftWrap{
    width: 200px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: #0055ff;
  }
  .leftWrap .logo{
    width: 100px;
    position: absolute;
    left: 50px;
    top: 40px;
  }
  .leftWrap .phoneNum{
    width: 100%;
    position: absolute;
    bottom: 160px;
    text-align: center;
    line-height: 40px;
    font-size: 20px;
    color: white;
  }
  .leftWrap .phone{
    width: 21px;
    position: absolute;
    left: 60px;
    bottom: 134px;
  }
  .leftWrap .weixin{
    width: 33px;
    position: absolute;
    right: 60px;
    bottom: 134px;
  }
  .leftWrap .qr{
    width: 86px;
    position: absolute;
    left: 57px;
    bottom: 30px;
  }
  .rightWrap{
    position: absolute;
    left: 200px;
    bottom:0 ;
    right: 0;
    top: 0;
    background-color: black;
    box-sizing:border-box;
  }
  .rightWrap .myswiper{
    width: 100%;
    height: 100%;
    position: relative;
  }

  .rightWrap .myswiper .myslide{
    width: 100%;
    height: 100%;
  }
  .rightWrap .myswiper .myslide video{
    display: block;
    min-width: 100%;
    min-height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .myslide .bgImg{
    display: block;
    min-width: 100%;
    min-height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .myslide .title1{
    display: block;
    position: absolute;
    left: 95px;
    top: 350px;
    opacity: 0;
    animation: ani2 0.5s ease-in-out forwards;
  }
  @keyframes ani2 {
    0%{opacity: 0;top: 50px;}
    100%{opacity: 1;top: 350px;}
  }
  .myslide .info1{
    display: block;
    position: absolute;
    left: -1000px;
    top: 500px;
    width: 1000px;
    font-size: 30px;
    color: white;
    line-height: 60px;
    font-weight: bold;
    transform: skew(60deg);
    margin: 0;
    padding: 0;
    animation: ani3 0.5s ease-in-out forwards;
  }
  @keyframes ani3 {
    0%{ left: -1000px;transform: skew(60deg);}
    100%{left: 95px;transform: skew(0deg);}
  }
  .myslide .name1{
    display: block;
    position: absolute;
    left: 164px;
    top: 120px;
    font-size: 50px;
    color: #3a9ee5;
    line-height: 50px;
    font-weight: bold;
    margin: 0;
    padding: 0;
  }
  .myslide .pic1{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-20%);
    animation: ani4 0.5s ease-in-out forwards;
  }
  @keyframes ani4 {
    0%{ bottom: -500px;}
    100%{bottom: 0px;}
  }
  .myslide .pic2, .myslide .pic3, .myslide .pic4, .myslide .pic5{
    position: absolute;
    top: -10%;
    left: 50%;
    transform: translateX(-50%)  translateY(-50%);
    animation: ani5 0.5s ease-in-out forwards;
    opacity: 0;
  }
  @keyframes ani5 {
    0%{ top: -10%;opacity: 0;}
    100%{top: 50%;opacity: 1;}
  }
</style>
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      data: [],
      activeNum: 0,
      phoneShow: false,
      swiperOptions: {
        direction: 'vertical',
        mousewheel: true,
        slidesPerView: 1,
        on: {
          slideChange: () => {
            this.activeNum = this.$refs.mySwiper.$swiper.activeIndex
            if(this.activeNum !== 0) {
              this.$refs.myvideo.currentTime = 0
              this.$refs.myvideo.pause()
            }else{
              this.$refs.myvideo.currentTime = 0
              this.$refs.myvideo.play()
            }
          }
        }
      }
    }
  },
  created() {

  },
  methods: {
    play() {
      this.$refs.myvideo.play()
    }
  }
}
</script>
